import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { propTypes, defaultProps } from 'shared/proptypes/Company';
import styles from './CompanyName.module.scss';

const CompanyName = ({
  company,
  linkTo,
  linkTarget,
  linkElement,
  className,
  children,
  elementType: Element,
  onClick
}) => {
  const content = (
    <Element className={styles.name}>
      <i className={`la ${company.agency ? 'la-user-tie' : 'la-building'}`} />
      {company.name ? company.name : children}
    </Element>
  );
  return (
    <div className={`${styles.company} ${className}`}>
      {linkTo ? linkElement === 'a' ? (
        <a href={linkTo} target={linkTarget} onClick={onClick}>
          {content}
        </a>
      ) : (
        <Link to={linkTo} target={linkTarget} onClick={onClick}>
          {content}
        </Link>
      ) : content}
    </div>
  );
};

CompanyName.propTypes = {
  company: PropTypes.shape(propTypes),
  linkTo: PropTypes.string,
  linkTarget: PropTypes.string,
  linkElement: PropTypes.elementType,
  className: PropTypes.string,
  children: PropTypes.elementType,
  elementType: PropTypes.string,
  onClick: PropTypes.func,
};

CompanyName.defaultProps = {
  company: defaultProps,
  linkTo: null,
  linkTarget: null,
  linkElement: Link,
  className: '',
  children: null,
  elementType: 'h3',
  onClick() {},
};

export default CompanyName;
